import {
  GET_CLIENTS,
  CLEAR_CLIENTS,
  ADD_CLIENT,
  DELETE_CLIENT,
  SET_CURRENT,
  CLEAR_CURRENT,
  UPDATE_CLIENT,
  FILTER_CLIENTS,
  CLEAR_FILTER,
  CLIENT_ERROR
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case GET_CLIENTS:
      //console.log('clientReducer', action.payload);
      return {
        ...state,
        clients: action.payload.data,
        loading: false
      };
    case ADD_CLIENT:
      return {
        ...state,
        clients: [action.payload.data, ...state.clients],
        loading: false
      };
    case UPDATE_CLIENT:
      //console.log('updateClient', action.payload);
      return {
        ...state,
        clients: state.clients.map(client =>
          client.id === action.payload.data.id ? action.payload.data : client
        ),
        loading: false
      };
    case DELETE_CLIENT:
      //console.log(action);
      return {
        ...state,
        clients: state.clients.filter(client => client.id !== action.payload),
        loading: false
      };
    case CLEAR_CLIENTS:
      return {
        ...state,
        clients: null,
        filtered: null,
        error: null,
        current: null,
        loading: false
      };
    case SET_CURRENT:
      return {
        ...state,
        current: action.payload
      };
    case CLEAR_CURRENT:
      return {
        ...state,
        current: null
      };
    case FILTER_CLIENTS:
      return {
        ...state,
        filtered: state.clients.filter(client => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return (
            client.name.match(regex) ||
            client.contactName.match(regex) ||
            client.contactEmail.match(regex) ||
            client.contactPhone.match(regex)
          );
        }),
        loading: false
      };
    case CLEAR_FILTER:
      return {
        ...state,
        filtered: null,
        loading: false
      };
    case CLIENT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
